module.exports = __webpack_public_path__ + "img/logo.5c39c395.jpg";